export function checkDomain(...domains) {
  const domain = window.location.hostname;
  return domains.includes(domain);
}
